<template>
  <v-col>
    <v-tabs centered>
      <v-tab>Product Units</v-tab>
      <v-tab>Edit</v-tab>
      <v-tab-item>
        <v-row>
          <v-col
            class="text-center"
            cols="12"
          >
            <v-chip
              v-for="term in units.split(',')"
              :key="term"
              class="mb-1 ml-1"
            >
              <v-icon left>
                mdi-bookmark-check
              </v-icon>
              {{ term }}
            </v-chip>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <v-textarea
          v-model="units"
          :error-messages="errors.getMessage('productUnits')"
        />
        <v-btn
          class="info mt-3"
          @click="unitsUpdate"
        >
          Update units
        </v-btn>
      </v-tab-item>
    </v-tabs>
  </v-col>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      units: "",
    };
  },
  computed: {
    ...mapGetters({
      main: "configs/overall",
      errors: "validation/pull",
    }),
  },
  mounted() {
    const data = this.main.productUnits;
    if (data !== null) {
      this.$data.units = data;
    }
  },
  methods: {
    unitsUpdate() {
      Event.$emit("updateConfigs", {
        path: "setting-units-update",
        payload: { productUnits: this.units },
      });
    },
  },
};
</script>
